import Vue from 'vue'
import axios from "axios";
import $router from "../router/index";
import layer from "@/utils/layer";
import { Toast } from "vant";
import * as util from "@/utils/utils";
import store from '@/store'

Toast.allowMultiple(); // 允许多个Toast实例

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api 的 base_url
    timeout: 60000 // 请求超时时间
});

// request 拦截器
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        // 如果用戶信息存在
      let token = localStorage.getItem("Authorization");

      if (token){
        // 没有取本地调试token
        config.headers['Authorization'] = token;
      }
        return config;
    },
    error => {
        // Do something with request error
        return Promise.reject(error);
    }
);
// response 拦截器
service.interceptors.response.use(
    response => {
        let res = response.data;
        if (res.code === 200 || res.code === '200' || res.code === '300') {
            return res;
        } else if (parseInt(res.code) === 401) {
            layer.toast(res.msg);
          $router.push("/login");
        } else if (parseInt(res.code) === 403) {
          layer.toast(res.msg);
          $router.push("/login");
        } else {
            layer.toast(res.msg || res.message || '网络异常，请稍后重试！');
            return Promise.reject(res); // 请求code返回-1当错误处理
        }
    },
    err => {
        // 接口错误提示
        if (err.response && err.response.status) {
            let msg = '出错了'
            switch (err.response.status) {
                case 400:
                    msg = '请求错误'
                    break
                case 401:
                    msg = '未授权，请登录'
                    break
                case 403:
                    msg = '拒绝访问'
                    break
                case 404:
                    msg = `请求地址出错: ${err.response.config.url}`
                    break
                case 408:
                    msg = '请求超时'
                    break
                case 500:
                    msg = '服务器错误'
                    break
                case 501:
                    msg = '服务未实现'
                    break
                case 502:
                    msg = '网关错误'
                    break
                case 503:
                    msg = '服务不可用'
                    break
                case 504:
                    msg = '网关超时'
                    break
                case 505:
                    msg = 'HTTP版本不受支持'
                    break
                default:
            }
            layer.toast(msg)

        }
        return Promise.reject(err);
    }
);
export default service




// WEBPACK FOOTER //
// ./src/utils/request.js